import React from 'react';
import Ccm from '../components/Ccm';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/About';
import Services from '../components/Services';

class Home extends React.Component {
  render() {
    return (
      <>
        <Hero />
        <Intro />
        <Services />
        <Ccm />
        <Footer />
      </>
    );
  }
}

export default Home;
